const data = {
  counterText: 'সীমিত স্লট উপলব্ধ',
  loading: 'লোড হচ্ছে',
  next: 'পরবর্তী',
  previous: 'ಹಿಂದಿನ',
  smCounterText: 'সীমিত স্লট বাকি',
};

export default data;
